import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=a72a50fc&scoped=true&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a50fc",
  null
  
)

export default component.exports